<template>
  <div class="dictionary-management">
    <el-container>
      <!-- 头部标题 -->
      <el-header height="60px">
        <div class="header-title">
          <!-- <h2>医院数据字典管理系统</h2> -->
          <div class="header-actions">
            <el-button type="primary" size="small" @click="handleAddDictType">
              新增字典库
            </el-button>
          </div>
        </div>
      </el-header>

      <el-container class="main-container">
        <!-- 左侧字典库分类树 -->
        <el-aside width="250px" class="aside-container">
          <div class="aside-header">
            <span>字典库分类</span>
            <el-input
              placeholder="搜索字典"
              prefix-icon="el-icon-search"
              v-model="treeFilterText"
              size="small">
            </el-input>
          </div>
          <el-tree
            ref="dictTree"
            :data="dictTypeTree"
            :props="defaultProps"
            :filter-node-method="filterNode"
            highlight-current
            @node-click="handleNodeClick">
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <span>{{ node.label }}</span>
              <span class="dict-code">{{ data.dictCode }}</span>
            </span>
          </el-tree>
        </el-aside>

        <!-- 右侧内容区域 -->
        <el-main>
          <!-- 字典信息卡片 -->
          <el-card v-if="currentDictType" class="dict-info-card">
            <div slot="header" class="clearfix">
              <span>{{ currentDictType.dictName }}</span>
              <div class="card-header-actions">
                <el-tag size="mini" effect="plain">当前版本: v{{ currentDictType.currentVersion }}</el-tag>
                <el-button type="primary" size="mini" @click="handleAddDictData">添加字典项</el-button>
                <el-button type="success" size="mini" @click="handleCreateNewVersion">发布新版本</el-button>
                <el-button type="info" size="mini" @click="activeTabName = 'version'">查看版本历史</el-button>
              </div>
            </div>

            <el-tabs v-model="activeTabName" type="border-card">
              <!-- 字典数据标签页 -->
              <el-tab-pane label="字典数据" name="data">
                <div class="filter-container">
                  <el-input
                    placeholder="搜索字典项"
                    v-model="dataSearch"
                    style="width: 200px;"
                    class="filter-item"
                    clearable
                    prefix-icon="el-icon-search"
                    @input="handleDataSearch">
                  </el-input>
                  <el-select v-model="dataStatus" placeholder="状态" style="width: 120px;" @change="handleDataSearch">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="启用" value="1"></el-option>
                    <el-option label="停用" value="0"></el-option>
                  </el-select>
                </div>
                
                <el-table :data="filteredDictData" border style="width: 100%">
                  <el-table-column prop="dictLabel" label="字典标签" min-width="150"></el-table-column>
                  <el-table-column prop="dictValue" label="字典键值" width="120"></el-table-column>
                  <el-table-column prop="dictSort" label="排序" width="80"></el-table-column>
                  <el-table-column label="状态" width="100">
                    <template slot-scope="scope">
                      <el-switch
                        v-model="scope.row.status"
                        :active-value="1"
                        :inactive-value="0"
                        @change="handleStatusChange(scope.row)">
                      </el-switch>
                    </template>
                  </el-table-column>
                  <el-table-column prop="remark" label="备注" min-width="150"></el-table-column>
                  <el-table-column label="操作" width="150" align="center">
                    <template slot-scope="scope">
                      <el-button
                        size="mini"
                        type="text"
                        @click="handleEditDictData(scope.row)">编辑</el-button>
                      <el-button
                        size="mini"
                        type="text"
                        @click="handleDeleteDictData(scope.row)">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-tab-pane>

              <!-- 版本历史标签页 -->
              <el-tab-pane label="版本历史" name="version">
                <el-timeline>
                  <el-timeline-item
                    v-for="(version, index) in versionHistory"
                    :key="index"
                    :timestamp="version.updateTime"
                    :type="index === 0 ? 'primary' : ''">
                    <el-card>
                      <div class="version-header">
                        <h4>版本 {{ version.versionNumber }}</h4>
                        <div class="version-meta">
                          <span>发布人: {{ version.updatedBy }}</span>
                          <el-tag size="mini" :type="version.current ? 'success' : 'info'">
                            {{ version.current ? '当前版本' : '历史版本' }}
                          </el-tag>
                        </div>
                      </div>
                      <div class="version-changes">
                        <h5>变更内容:</h5>
                        <ul>
                          <li v-for="(change, cidx) in version.changes" :key="cidx">
                            {{ change }}
                          </li>
                        </ul>
                      </div>
                      <div class="version-actions">
                        <el-button 
                          size="mini" 
                          @click="handleViewVersion(version)">查看详情</el-button>
                        <el-button 
                          size="mini" 
                          type="primary" 
                          v-if="!version.current && index !== 0"
                          @click="handleCompareVersions(version, versionHistory[index-1])">
                          与上一版本比较
                        </el-button>
                        <el-button 
                          size="mini" 
                          type="warning" 
                          v-if="!version.current"
                          @click="handleRollbackVersion(version)">回滚到此版本</el-button>
                      </div>
                    </el-card>
                  </el-timeline-item>
                </el-timeline>
              </el-tab-pane>
            </el-tabs>
          </el-card>
          
          <!-- 未选择字典时的提示 -->
          <el-empty v-else description="请选择左侧字典库"></el-empty>
        </el-main>
      </el-container>
    </el-container>

    <!-- 新增/编辑字典类型对话框 -->
    <el-dialog :title="dialogType === 'add' ? '新增字典库' : '编辑字典库'" :visible.sync="dictTypeDialog" width="500px">
      <el-form :model="dictTypeForm" :rules="dictTypeRules" ref="dictTypeForm" label-width="100px">
        <el-form-item label="字典名称" prop="dictName">
          <el-input v-model="dictTypeForm.dictName" placeholder="请输入字典名称"></el-input>
        </el-form-item>
        <el-form-item label="字典编码" prop="dictCode">
          <el-input v-model="dictTypeForm.dictCode" placeholder="请输入字典编码"></el-input>
        </el-form-item>
        <el-form-item label="字典状态" prop="status">
          <el-radio-group v-model="dictTypeForm.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="dictTypeForm.remark" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dictTypeDialog = false">取 消</el-button>
        <el-button type="primary" @click="submitDictType">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 新增/编辑字典数据对话框 -->
    <el-dialog :title="dialogType === 'add' ? '新增字典项' : '编辑字典项'" :visible.sync="dictDataDialog" width="500px">
      <el-form :model="dictDataForm" :rules="dictDataRules" ref="dictDataForm" label-width="100px">
        <el-form-item label="字典标签" prop="dictLabel">
          <el-input v-model="dictDataForm.dictLabel" placeholder="请输入字典标签"></el-input>
        </el-form-item>
        <el-form-item label="字典键值" prop="dictValue">
          <el-input v-model="dictDataForm.dictValue" placeholder="请输入字典键值"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="dictSort">
          <el-input-number v-model="dictDataForm.dictSort" :min="0" :max="999" controls-position="right"></el-input-number>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="dictDataForm.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="dictDataForm.remark" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dictDataDialog = false">取 消</el-button>
        <el-button type="primary" @click="submitDictData">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 发布新版本对话框 -->
    <el-dialog title="发布新版本" :visible.sync="newVersionDialog" width="600px">
      <el-form :model="versionForm" :rules="versionRules" ref="versionForm" label-width="100px">
        <el-form-item label="版本号" prop="versionNumber">
          <el-input v-model="versionForm.versionNumber" placeholder="如：1.0.1" disabled></el-input>
        </el-form-item>
        <el-form-item label="变更说明" prop="changes">
          <div class="changes-container">
            <div v-for="(change, index) in versionForm.changes" :key="index" class="change-item">
              <el-input v-model="versionForm.changes[index]" placeholder="请输入变更内容"></el-input>
              <el-button 
                type="danger" 
                icon="el-icon-delete" 
                circle 
                size="mini" 
                @click="removeChange(index)"
                v-if="versionForm.changes.length > 1">
              </el-button>
            </div>
            <div class="add-change">
              <el-button type="primary" size="mini" icon="el-icon-plus" @click="addChange">
                添加变更说明
              </el-button>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="newVersionDialog = false">取 消</el-button>
        <el-button type="primary" @click="submitVersion">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 版本比较对话框 -->
    <el-dialog title="版本比较" :visible.sync="versionCompareDialog" width="800px">
      <div v-if="compareData.from && compareData.to" class="compare-container">
        <div class="compare-info">
          <div class="compare-version">
            <div>
              <h4>从: v{{ compareData.from.versionNumber }}</h4>
              <p>{{ compareData.from.updateTime }}</p>
            </div>
            <div>
              <h4>到: v{{ compareData.to.versionNumber }}</h4>
              <p>{{ compareData.to.updateTime }}</p>
            </div>
          </div>
        </div>
        <div class="compare-content">
          <el-table :data="compareData.diff" border>
            <el-table-column prop="dictLabel" label="字典标签" width="150"></el-table-column>
            <el-table-column prop="dictValue" label="字典键值" width="100"></el-table-column>
            <el-table-column label="变更类型" width="100">
              <template slot-scope="scope">
                <el-tag :type="getChangeTypeTag(scope.row.changeType)">
                  {{ scope.row.changeType }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="旧值" min-width="200">
              <template slot-scope="scope">
                <div v-if="scope.row.oldValue">
                  <div>标签: {{ scope.row.oldValue.dictLabel }}</div>
                  <div>状态: {{ scope.row.oldValue.status === 1 ? '启用' : '停用' }}</div>
                  <div v-if="scope.row.oldValue.remark">备注: {{ scope.row.oldValue.remark }}</div>
                </div>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="新值" min-width="200">
              <template slot-scope="scope">
                <div v-if="scope.row.newValue">
                  <div>标签: {{ scope.row.newValue.dictLabel }}</div>
                  <div>状态: {{ scope.row.newValue.status === 1 ? '启用' : '停用' }}</div>
                  <div v-if="scope.row.newValue.remark">备注: {{ scope.row.newValue.remark }}</div>
                </div>
                <span v-else>-</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>

    <!-- 版本详情对话框 -->
    <el-dialog title="版本详情" :visible.sync="versionDetailDialog" width="800px">
      <div v-if="selectedVersion" class="version-detail">
        <div class="version-detail-header">
          <h3>版本 {{ selectedVersion.versionNumber }}</h3>
          <el-tag :type="selectedVersion.current ? 'success' : 'info'">
            {{ selectedVersion.current ? '当前版本' : '历史版本' }}
          </el-tag>
        </div>
        <div class="version-detail-meta">
          <p><strong>发布时间:</strong> {{ selectedVersion.updateTime }}</p>
          <p><strong>发布人:</strong> {{ selectedVersion.updatedBy }}</p>
        </div>
        <div class="version-detail-changes">
          <h4>变更说明:</h4>
          <ul>
            <li v-for="(change, index) in selectedVersion.changes" :key="index">
              {{ change }}
            </li>
          </ul>
        </div>
        <div class="version-detail-content">
          <h4>版本内容:</h4>
          <el-table :data="selectedVersion.data" border>
            <el-table-column prop="dictLabel" label="字典标签" min-width="150"></el-table-column>
            <el-table-column prop="dictValue" label="字典键值" width="120"></el-table-column>
            <el-table-column prop="dictSort" label="排序" width="80"></el-table-column>
            <el-table-column label="状态" width="100">
              <template slot-scope="scope">
                <el-tag :type="scope.row.status === 1 ? 'success' : 'info'">
                  {{ scope.row.status === 1 ? '启用' : '停用' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="备注" min-width="150"></el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>

    <!-- 回滚确认对话框 -->
    <el-dialog title="回滚确认" :visible.sync="rollbackDialog" width="450px">
      <div class="rollback-warning">
        <i class="el-icon-warning"></i>
        <p>您确定要回滚到版本 v{{ rollbackVersion ? rollbackVersion.versionNumber : '' }} 吗？</p>
        <p class="warning-text">此操作将会覆盖当前版本数据，且无法撤销!</p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="rollbackDialog = false">取 消</el-button>
        <el-button type="warning" @click="confirmRollback">确认回滚</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'DictionaryManagement',
  data() {
    return {
      // 左侧树过滤文本
      treeFilterText: '',
      
      // 字典数据过滤
      dataSearch: '',
      dataStatus: '',
      
      // 当前选中的字典类型
      currentDictType: null,
      
      // 标签页激活标签
      activeTabName: 'data',
      
      // 对话框控制
      dictTypeDialog: false,
      dictDataDialog: false,
      newVersionDialog: false,
      versionCompareDialog: false,
      versionDetailDialog: false,
      rollbackDialog: false,
      
      // 对话框类型（添加/编辑）
      dialogType: 'add',
      
      // 字典类型表单
      dictTypeForm: {
        dictId: null,
        dictName: '',
        dictCode: '',
        status: 1,
        remark: ''
      },
      
      // 字典类型表单验证规则
      dictTypeRules: {
        dictName: [
          { required: true, message: '请输入字典名称', trigger: 'blur' }
        ],
        dictCode: [
          { required: true, message: '请输入字典编码', trigger: 'blur' }
        ]
      },
      
      // 字典数据表单
      dictDataForm: {
        dictCode: null,
        dictLabel: '',
        dictValue: '',
        dictSort: 0,
        status: 1,
        remark: ''
      },
      
      // 字典数据表单验证规则
      dictDataRules: {
        dictLabel: [
          { required: true, message: '请输入字典标签', trigger: 'blur' }
        ],
        dictValue: [
          { required: true, message: '请输入字典键值', trigger: 'blur' }
        ]
      },
      
      // 版本表单
      versionForm: {
        versionNumber: '',
        changes: ['']
      },
      
      // 版本表单验证规则
      versionRules: {
        changes: [
          { required: true, message: '请输入变更说明', trigger: 'blur' }
        ]
      },
      
      // 版本比较数据
      compareData: {
        from: null,
        to: null,
        diff: []
      },
      
      // 选中的版本
      selectedVersion: null,
      
      // 要回滚的版本
      rollbackVersion: null,
      
      // 树形控件配置
      defaultProps: {
        children: 'children',
        label: 'dictName'
      },
      
      // 字典类型树
      dictTypeTree: [
        {
          dictId: 1,
          dictName: '系统状态',
          dictCode: 'sys_status',
          status: 1,
          currentVersion: '1.2.0',
          remark: '系统状态字典'
        },
        {
          dictId: 2,
          dictName: '用户性别',
          dictCode: 'sys_user_sex',
          status: 1,
          currentVersion: '1.0.1',
          remark: '用户性别字典'
        },
        {
          dictId: 3,
          dictName: '菜单状态',
          dictCode: 'sys_menu_status',
          status: 0,
          currentVersion: '1.0.0',
          remark: '菜单状态字典'
        },
        {
          dictId: 4,
          dictName: '数据状态',
          dictCode: 'data_status',
          status: 1,
          currentVersion: '2.1.0',
          remark: '通用数据状态'
        },
        {
          dictId: 5,
          dictName: '疾病分类',
          dictCode: 'disease_category',
          status: 1,
          currentVersion: '3.0.2',
          remark: '医院疾病分类字典'
        },
        {
          dictId: 6,
          dictName: '药物分类',
          dictCode: 'medicine_category',
          status: 1,
          currentVersion: '2.2.1',
          remark: '药物分类字典'
        },
        {
          dictId: 7,
          dictName: '检查项目',
          dictCode: 'examination_items',
          status: 1,
          currentVersion: '1.5.3',
          remark: '医疗检查项目字典'
        }
      ],
      
      // 字典数据列表（当前选中的字典类型下的数据）
      dictDataList: [
        // 系统状态
        {
          dictCode: 'sys_status',
          dictLabel: '正常',
          dictValue: '1',
          dictSort: 1,
          status: 1,
          remark: '正常状态'
        },
        {
          dictCode: 'sys_status',
          dictLabel: '停用',
          dictValue: '0',
          dictSort: 2,
          status: 1,
          remark: '停用状态'
        },
        // 用户性别
        {
          dictCode: 'sys_user_sex',
          dictLabel: '男',
          dictValue: '0',
          dictSort: 1,
          status: 1,
          remark: '性别男'
        },
        {
          dictCode: 'sys_user_sex',
          dictLabel: '女',
          dictValue: '1',
          dictSort: 2,
          status: 1,
          remark: '性别女'
        },
        {
          dictCode: 'sys_user_sex',
          dictLabel: '未知',
          dictValue: '2',
          dictSort: 3,
          status: 0,
          remark: '性别未知'
        },
        // 数据状态
        {
          dictCode: 'data_status',
          dictLabel: '有效',
          dictValue: '1',
          dictSort: 1,
          status: 1,
          remark: '有效数据'
        },
        {
          dictCode: 'data_status',
          dictLabel: '无效',
          dictValue: '0',
          dictSort: 2,
          status: 1,
          remark: '无效数据'
        },
        {
          dictCode: 'data_status',
          dictLabel: '待审核',
          dictValue: '2',
          dictSort: 3,
          status: 1,
          remark: '待审核数据'
        },
        {
          dictCode: 'data_status',
          dictLabel: '已归档',
          dictValue: '3',
          dictSort: 4,
          status: 0,
          remark: '已归档数据'
        },
        // 疾病分类
        {
          dictCode: 'disease_category',
          dictLabel: '内科疾病',
          dictValue: '1',
          dictSort: 1,
          status: 1,
          remark: '内科相关疾病'
        },
        {
          dictCode: 'disease_category',
          dictLabel: '外科疾病',
          dictValue: '2',
          dictSort: 2,
          status: 1,
          remark: '外科相关疾病'
        },
        {
          dictCode: 'disease_category',
          dictLabel: '精神疾病',
          dictValue: '3',
          dictSort: 3,
          status: 1,
          remark: '精神类疾病'
        },
        {
          dictCode: 'disease_category',
          dictLabel: '传染病',
          dictValue: '4',
          dictSort: 4,
          status: 1,
          remark: '传染类疾病'
        }
      ],
      
      // 版本历史记录（假数据）
      versionHistoryData: [
        // 系统状态版本历史
        [
          {
            dictCode: 'sys_status',
            versionNumber: '1.2.0',
            updateTime: '2025-03-15 14:30:22',
            updatedBy: '管理员',
            current: true,
            changes: [
              '添加了"维护中"状态',
              '优化了状态描述'
            ],
            data: [
              {
                dictLabel: '正常',
                dictValue: '1',
                dictSort: 1,
                status: 1,
                remark: '正常状态'
              },
              {
                dictLabel: '停用',
                dictValue: '0',
                dictSort: 2,
                status: 1,
                remark: '停用状态'
              },
              {
                dictLabel: '维护中',
                dictValue: '2',
                dictSort: 3,
                status: 1,
                remark: '系统维护中'
              }
            ]
          },
          {
            dictCode: 'sys_status',
            versionNumber: '1.1.0',
            updateTime: '2024-12-01 09:15:36',
            updatedBy: '技术主管',
            current: false,
            changes: [
              '更新了停用状态的描述'
            ],
            data: [
              {
                dictLabel: '正常',
                dictValue: '1',
                dictSort: 1,
                status: 1,
                remark: '正常状态'
              },
              {
                dictLabel: '停用',
                dictValue: '0',
                dictSort: 2,
                status: 1,
                remark: '系统停用状态'
              }
            ]
          },
          {
            dictCode: 'sys_status',
            versionNumber: '1.0.0',
            updateTime: '2024-10-15 11:20:45',
            updatedBy: '系统管理员',
            current: false,
            changes: [
              '初始版本创建'
            ],
            data: [
              {
                dictLabel: '正常',
                dictValue: '1',
                dictSort: 1,
                status: 1,
                remark: '正常'
              },
              {
                dictLabel: '停用',
                dictValue: '0',
                dictSort: 2,
                status: 1,
                remark: '停用'
              }
            ]
          }
        ],
        
        // 用户性别版本历史
        [
          {
            dictCode: 'sys_user_sex',
            versionNumber: '1.0.1',
            updateTime: '2024-11-05 16:45:12',
            updatedBy: '系统管理员',
            current: true,
            changes: [
              '添加了"未知"选项',
              '规范了字典说明'
            ],
            data: [
              {
                dictLabel: '男',
                dictValue: '0',
                dictSort: 1,
                status: 1,
                remark: '性别男'
              },
              {
                dictLabel: '女',
                dictValue: '1',
                dictSort: 2,
                status: 1,
                remark: '性别女'
              },
              {
                dictLabel: '未知',
                dictValue: '2',
                dictSort: 3,
                status: 0,
                remark: '性别未知'
              }
            ]
          },
          {
            dictCode: 'sys_user_sex',
            versionNumber: '1.0.0',
            updateTime: '2024-09-20 10:30:22',
            updatedBy: '系统管理员',
            current: false,
            changes: [
              '初始版本创建'
            ],
            data: [
              {
                dictLabel: '男',
                dictValue: '0',
                dictSort: 1,
                status: 1,
                remark: '男'
              },
              {
                dictLabel: '女',
                dictValue: '1',
                dictSort: 2,
                status: 1,
                remark: '女'
              }
            ]
          }
        ],
        
        // 疾病分类版本历史
        [
          {
            dictCode: 'disease_category',
            versionNumber: '3.0.2',
            updateTime: '2025-04-20 09:35:26',
            updatedBy: '医疗主任',
            current: true,
            changes: [
              '优化了疾病分类描述',
              '调整了部分分类排序'
            ],
            data: [
              {
                dictLabel: '内科疾病',
                dictValue: '1',
                dictSort: 1,
                status: 1,
                remark: '内科相关疾病'
              },
              {
                dictLabel: '外科疾病',
                dictValue: '2',
                dictSort: 2,
                status: 1,
                remark: '外科相关疾病'
              },
              {
                dictLabel: '精神疾病',
                dictValue: '3',
                dictSort: 3,
                status: 1,
                remark: '精神类疾病'
              },
              {
                dictLabel: '传染病',
                dictValue: '4',
                dictSort: 4,
                status: 1,
                remark: '传染类疾病'
              }
            ]
          },
          {
            dictCode: 'disease_category',
            versionNumber: '3.0.1',
            updateTime: '2025-02-15 14:20:15',
            updatedBy: '临床医师',
            current: false,
            changes: [
              '添加了传染病分类',
              '调整了分类顺序'
            ],
            data: [
              {
                dictLabel: '内科疾病',
                dictValue: '1',
                dictSort: 1,
                status: 1,
                remark: '内科疾病'
              },
              {
                dictLabel: '外科疾病',
                dictValue: '2',
                dictSort: 2,
                status: 1,
                remark: '外科疾病'
              },
              {
                dictLabel: '精神疾病',
                dictValue: '3',
                dictSort: 4,
                status: 1,
                remark: '精神疾病'
              },
              {
                dictLabel: '传染病',
                dictValue: '4',
                dictSort: 3,
                status: 1,
                remark: '传染性疾病'
              }
            ]
          },
          {
            dictCode: 'disease_category',
            versionNumber: '3.0.0',
            updateTime: '2025-01-10 10:45:30',
            updatedBy: '医疗主任',
            current: false,
            changes: [
              '重构疾病分类体系',
              '简化分类结构',
              '更新分类说明'
            ],
            data: [
              {
                dictLabel: '内科疾病',
                dictValue: '1',
                dictSort: 1,
                status: 1,
                remark: '内科疾病'
              },
              {
                dictLabel: '外科疾病',
                dictValue: '2',
                dictSort: 2,
                status: 1,
                remark: '外科疾病'
              },
              {
                dictLabel: '精神疾病',
                dictValue: '3',
                dictSort: 3,
                status: 1,
                remark: '精神疾病'
              }
            ]
          },
          {
            dictCode: 'disease_category',
            versionNumber: '2.1.0',
            updateTime: '2024-11-05 09:20:15',
            updatedBy: '医疗总监',
            current: false,
            changes: [
              '更新了部分疾病分类',
              '调整了疾病编码'
            ],
            data: [
              {
                dictLabel: '心脑血管疾病',
                dictValue: 'A001',
                dictSort: 1,
                status: 1,
                remark: '心脑血管相关疾病'
              },
              {
                dictLabel: '呼吸系统疾病',
                dictValue: 'A002',
                dictSort: 2,
                status: 1,
                remark: '呼吸系统相关疾病'
              },
              {
                dictLabel: '消化系统疾病',
                dictValue: 'A003',
                dictSort: 3,
                status: 1,
                remark: '消化系统相关疾病'
              }
            ]
          }
        ]
      ]
    };
  },
  computed: {
    // 根据当前选中的字典类型过滤字典数据
    filteredDictData() {
      if (!this.currentDictType) return [];
      
      let data = this.dictDataList.filter(item => item.dictCode === this.currentDictType.dictCode);
      
      // 搜索过滤
      if (this.dataSearch) {
        data = data.filter(item => 
          item.dictLabel.includes(this.dataSearch) || 
          item.dictValue.includes(this.dataSearch) ||
          (item.remark && item.remark.includes(this.dataSearch))
        );
      }
      
      // 状态过滤
      if (this.dataStatus !== '') {
        data = data.filter(item => item.status === parseInt(this.dataStatus));
      }
      
      return data;
    },
    
    // 当前字典的版本历史
    versionHistory() {
      if (!this.currentDictType) return [];
      
      // 在实际应用中，这里会从服务器获取版本历史
      // 这里简单模拟，根据字典类型返回对应的版本历史
      let history = [];
      
      if (this.currentDictType.dictCode === 'sys_status') {
        history = this.versionHistoryData[0];
      } else if (this.currentDictType.dictCode === 'sys_user_sex') {
        history = this.versionHistoryData[1];
      } else if (this.currentDictType.dictCode === 'disease_category') {
        history = this.versionHistoryData[2];
      } else {
        // 其他字典类型，暂无历史版本
        history = [
          {
            dictCode: this.currentDictType.dictCode,
            versionNumber: this.currentDictType.currentVersion,
            updateTime: '2025-05-09 10:00:00',
            updatedBy: '系统管理员',
            current: true,
            changes: ['初始版本创建'],
            data: this.filteredDictData
          }
        ];
      }
      
      return history;
    }
  },
  watch: {
    // 监听树过滤文本变化
    treeFilterText(val) {
      this.$refs.dictTree.filter(val);
    }
  },
  methods: {
    // 树节点过滤方法
    filterNode(value, data) {
      if (!value) return true;
      return data.dictName.indexOf(value) !== -1 || data.dictCode.indexOf(value) !== -1;
    },
    
    // 树节点点击事件
    handleNodeClick(data) {
      this.currentDictType = data;
      this.activeTabName = 'data';
      this.dataSearch = '';
      this.dataStatus = '';
    },
    
    // 数据搜索处理
    handleDataSearch() {
      // 本地数据过滤，无需额外处理
      // 在实际应用中，这里可能需要调用API
    },
    
    // 状态变更处理
    handleStatusChange(row) {
      this.$message.success(`状态已${row.status === 1 ? '启用' : '停用'}`);
    },
    
    // 添加字典类型
    handleAddDictType() {
      this.dialogType = 'add';
      this.dictTypeForm = {
        dictId: null,
        dictName: '',
        dictCode: '',
        status: 1,
        remark: ''
      };
      this.dictTypeDialog = true;
    },
    
    // 编辑字典类型
    handleEditDictType(row) {
      this.dialogType = 'edit';
      this.dictTypeForm = { ...row };
      this.dictTypeDialog = true;
    },
    
    // 提交字典类型表单
    submitDictType() {
      this.$refs.dictTypeForm.validate((valid) => {
        if (valid) {
          if (this.dialogType === 'add') {
            // 模拟添加逻辑
            const newDictType = {
              ...this.dictTypeForm,
              dictId: Math.floor(Math.random() * 1000) + 100, // 模拟ID生成
              currentVersion: '1.0.0' // 初始版本
            };
            this.dictTypeTree.push(newDictType);
            this.$message.success('添加成功');
          } else {
            // 模拟编辑逻辑
            const index = this.dictTypeTree.findIndex(item => item.dictId === this.dictTypeForm.dictId);
            if (index !== -1) {
              this.dictTypeTree[index] = { ...this.dictTypeTree[index], ...this.dictTypeForm };
              // 如果编辑的是当前选中的字典，也需要更新currentDictType
              if (this.currentDictType && this.currentDictType.dictId === this.dictTypeForm.dictId) {
                this.currentDictType = { ...this.dictTypeTree[index] };
              }
              this.$message.success('更新成功');
            }
          }
          this.dictTypeDialog = false;
        }
      });
    },
    
    // 添加字典数据
    handleAddDictData() {
      this.dialogType = 'add';
      this.dictDataForm = {
        dictCode: this.currentDictType.dictCode,
        dictLabel: '',
        dictValue: '',
        dictSort: this.filteredDictData.length + 1,
        status: 1,
        remark: ''
      };
      this.dictDataDialog = true;
    },
    
    // 编辑字典数据
    handleEditDictData(row) {
      this.dialogType = 'edit';
      this.dictDataForm = { ...row };
      this.dictDataDialog = true;
    },
    
    // 删除字典数据
    handleDeleteDictData(row) {
      this.$confirm('确认删除该字典项?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 模拟删除逻辑
        const index = this.dictDataList.findIndex(item => 
          item.dictCode === row.dictCode && 
          item.dictValue === row.dictValue);
        
        if (index !== -1) {
          this.dictDataList.splice(index, 1);
          this.$message.success('删除成功');
        }
      }).catch(() => {});
    },
    
    // 提交字典数据表单
    submitDictData() {
      this.$refs.dictDataForm.validate((valid) => {
        if (valid) {
          if (this.dialogType === 'add') {
            // 模拟添加逻辑
            this.dictDataList.push({ ...this.dictDataForm });
            this.$message.success('添加成功');
          } else {
            // 模拟编辑逻辑
            const index = this.dictDataList.findIndex(item => 
              item.dictCode === this.dictDataForm.dictCode && 
              item.dictValue === this.dictDataForm.dictValue);
            
            if (index !== -1) {
              this.dictDataList[index] = { ...this.dictDataForm };
              this.$message.success('更新成功');
            }
          }
          this.dictDataDialog = false;
        }
      });
    },
    
    // 发布新版本
    handleCreateNewVersion() {
      // 获取当前版本号并生成新版本号
      const currentVersion = this.currentDictType.currentVersion;
      const versionParts = currentVersion.split('.');
      const newMinor = parseInt(versionParts[2]) + 1;
      const newVersionNumber = `${versionParts[0]}.${versionParts[1]}.${newMinor}`;
      
      this.versionForm = {
        versionNumber: newVersionNumber,
        changes: ['']
      };
      
      this.newVersionDialog = true;
    },
    
    // 添加变更说明
    addChange() {
      this.versionForm.changes.push('');
    },
    
    // 移除变更说明
    removeChange(index) {
      this.versionForm.changes.splice(index, 1);
    },
    
    // 提交版本
    submitVersion() {
      if (!this.versionForm.changes[0]) {
        this.$message.error('请至少填写一条变更说明');
        return;
      }
      
      // 过滤空的变更说明
      const validChanges = this.versionForm.changes.filter(change => change.trim() !== '');
      
      if (validChanges.length === 0) {
        this.$message.error('请填写有效的变更说明');
        return;
      }
      
      // 获取当前时间
      const now = new Date();
      const timestamp = now.toLocaleString('zh-CN', { 
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      }).replace(/\//g, '-');
      
      // 创建新版本对象
      const newVersion = {
        dictCode: this.currentDictType.dictCode,
        versionNumber: this.versionForm.versionNumber,
        updateTime: timestamp,
        updatedBy: '当前用户', // 实际应用中应该从登录用户获取
        current: true,
        changes: validChanges,
        data: JSON.parse(JSON.stringify(this.filteredDictData))
      };
      
      // 查找当前字典的版本历史
      let historyIndex = -1;
      
      if (this.currentDictType.dictCode === 'sys_status') {
        historyIndex = 0;
      } else if (this.currentDictType.dictCode === 'sys_user_sex') {
        historyIndex = 1;
      } else if (this.currentDictType.dictCode === 'disease_category') {
        historyIndex = 2;
      }
      
      if (historyIndex !== -1) {
        // 将现有的当前版本标记为非当前版本
        this.versionHistoryData[historyIndex].forEach(version => {
          version.current = false;
        });
        
        // 添加新版本
        this.versionHistoryData[historyIndex].unshift(newVersion);
      } else {
        // 对于没有历史记录的字典类型，创建新的历史记录数组
        const newHistoryArray = [newVersion];
        this.versionHistoryData.push(newHistoryArray);
      }
      
      // 更新字典类型的当前版本号
      const index = this.dictTypeTree.findIndex(item => item.dictCode === this.currentDictType.dictCode);
      if (index !== -1) {
        this.dictTypeTree[index].currentVersion = this.versionForm.versionNumber;
        this.currentDictType.currentVersion = this.versionForm.versionNumber;
      }
      
      this.$message.success(`版本 ${this.versionForm.versionNumber} 已成功发布`);
      this.newVersionDialog = false;
      
      // 切换到版本历史标签页
      this.activeTabName = 'version';
    },
    
    // 查看版本详情
    handleViewVersion(version) {
      this.selectedVersion = version;
      this.versionDetailDialog = true;
    },
    
    // 比较版本
    handleCompareVersions(oldVersion, newVersion) {
      this.compareData = {
        from: oldVersion,
        to: newVersion,
        diff: this.computeDiff(oldVersion.data, newVersion.data)
      };
      
      this.versionCompareDialog = true;
    },
    
    // 计算两个版本之间的差异
    computeDiff(oldData, newData) {
      const diff = [];
      
      // 查找新增和修改的项
      newData.forEach(newItem => {
        const oldItem = oldData.find(item => item.dictValue === newItem.dictValue);
        
        if (!oldItem) {
          // 新增项
          diff.push({
            dictLabel: newItem.dictLabel,
            dictValue: newItem.dictValue,
            changeType: '新增',
            oldValue: null,
            newValue: { ...newItem }
          });
        } else if (
          oldItem.dictLabel !== newItem.dictLabel ||
          oldItem.status !== newItem.status ||
          oldItem.dictSort !== newItem.dictSort ||
          oldItem.remark !== newItem.remark
        ) {
          // 修改项
          diff.push({
            dictLabel: newItem.dictLabel,
            dictValue: newItem.dictValue,
            changeType: '修改',
            oldValue: { ...oldItem },
            newValue: { ...newItem }
          });
        }
      });
      
      // 查找删除的项
      oldData.forEach(oldItem => {
        const exists = newData.some(item => item.dictValue === oldItem.dictValue);
        
        if (!exists) {
          diff.push({
            dictLabel: oldItem.dictLabel,
            dictValue: oldItem.dictValue,
            changeType: '删除',
            oldValue: { ...oldItem },
            newValue: null
          });
        }
      });
      
      return diff;
    },
    
    // 获取变更类型对应的标签类型
    getChangeTypeTag(type) {
      switch (type) {
        case '新增':
          return 'success';
        case '修改':
          return 'warning';
        case '删除':
          return 'danger';
        default:
          return 'info';
      }
    },
    
    // 回滚版本
    handleRollbackVersion(version) {
      this.rollbackVersion = version;
      this.rollbackDialog = true;
    },
    
    // 确认回滚
    confirmRollback() {
      if (!this.rollbackVersion) return;
      
      // 更新字典数据
      const rollbackData = JSON.parse(JSON.stringify(this.rollbackVersion.data));
      
      // 查找并移除当前所有相关字典项
      const dictCode = this.rollbackVersion.dictCode;
      const indexes = [];
      
      this.dictDataList.forEach((item, index) => {
        if (item.dictCode === dictCode) {
          indexes.unshift(index); // 倒序添加索引，以便正确删除
        }
      });
      
      indexes.forEach(index => {
        this.dictDataList.splice(index, 1);
      });
      
      // 添加回滚版本的数据
      rollbackData.forEach(item => {
        this.dictDataList.push({ ...item });
      });
      
      // 更新版本历史中的当前版本标记
      let historyIndex = -1;
      
      if (dictCode === 'sys_status') {
        historyIndex = 0;
      } else if (dictCode === 'sys_user_sex') {
        historyIndex = 1;
      } else if (dictCode === 'disease_category') {
        historyIndex = 2;
      }
      
      if (historyIndex !== -1) {
        this.versionHistoryData[historyIndex].forEach(ver => {
          ver.current = ver.versionNumber === this.rollbackVersion.versionNumber;
        });
      }
      
      // 更新字典类型的当前版本号
      const index = this.dictTypeTree.findIndex(item => item.dictCode === dictCode);
      if (index !== -1) {
        this.dictTypeTree[index].currentVersion = this.rollbackVersion.versionNumber;
        
        if (this.currentDictType && this.currentDictType.dictCode === dictCode) {
          this.currentDictType.currentVersion = this.rollbackVersion.versionNumber;
        }
      }
      
      this.$message.success(`已成功回滚到版本 v${this.rollbackVersion.versionNumber}`);
      this.rollbackDialog = false;
      
      // 切换到数据标签页查看回滚后的数据
      this.activeTabName = 'data';
    }
  }
};
</script>

<style scoped>
.dictionary-management {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.header-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  border-bottom: 1px solid #ebeef5;
}

.main-container {
  flex: 1;
  overflow: hidden;
}

.aside-container {
  border-right: 1px solid #ebeef5;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.aside-header {
  padding: 15px;
  border-bottom: 1px solid #ebeef5;
}

.aside-header span {
  display: block;
  margin-bottom: 10px;
  font-weight: bold;
}

.dict-info-card {
  margin-bottom: 20px;
}

.card-header-actions {
  float: right;
  display: flex;
  align-items: center;
}

.card-header-actions .el-button {
  margin-left: 10px;
}

.card-header-actions .el-tag {
  margin-right: 10px;
}

.filter-container {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
}

.filter-item {
  margin-right: 10px;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.dict-code {
  font-size: 12px;
  color: #909399;
}

.version-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.version-meta {
  display: flex;
  align-items: center;
  gap: 15px;
}

.version-changes {
  margin: 10px 0;
}

.version-changes h5 {
  margin: 5px 0;
}

.version-actions {
  margin-top: 15px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.changes-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.change-item {
  display: flex;
  align-items: center;
  gap: 10px;
}

.add-change {
  margin-top: 10px;
  text-align: center;
}

.compare-container {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.compare-info {
  border-bottom: 1px solid #ebeef5;
  padding-bottom: 15px;
}

.compare-version {
  display: flex;
  justify-content: space-between;
}

.version-detail {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.version-detail-header {
  display: flex;
  align-items: center;
  gap: 10px;
}

.version-detail-meta {
  margin-bottom: 10px;
}

.version-detail-changes {
  margin-bottom: 15px;
}

.rollback-warning {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0;
}

.rollback-warning i {
  font-size: 48px;
  color: #E6A23C;
  margin-bottom: 15px;
}

.warning-text {
  color: #F56C6C;
  font-weight: bold;
  margin-top: 10px;
}
</style>